import {SENT, RECEIVED, NOT_INTERESTED, BUYER_DRAFT, CREATED} from 'rfp/bid-manager/main/core/actions/action/status';
import {
  asSingularOrPlural,
} from 'rfp/bid-manager/main/core/actions/bid-manager-actions-factory-helpers';
import createBidManagerUploadAction from './create-upload-action';

import UploadResponsesDialog from './UploadResponsesDialog.svelte';
import UploadResponsesAsBuyerDialog from './UploadResponsesAsBuyerDialog.svelte';
import ReUploadResponsesAsBuyerDialog from './ReUploadResponsesAsBuyerDialog.svelte';


export default {
  uploadResponses,
  uploadResponsesAsBuyer,
  reuploadResponsesAsBuyer,
}

const icon = 'open_in_browser';

function uploadResponses(actionResultHandler){
  return createBidManagerUploadAction({
    labelFn: report => asSingularOrPlural(report, 'Upload Response'),
    icon,
    validStates: [ SENT, RECEIVED, NOT_INTERESTED ],
    dialog: UploadResponsesDialog,
    actionResultHandler
  });
}

function uploadResponsesAsBuyer(actionResultHandler){
  return createBidManagerUploadAction({
    label: 'Manual Entry Upload',
    icon,
    validStates: [ CREATED, SENT, RECEIVED, NOT_INTERESTED ],
    dialog: UploadResponsesAsBuyerDialog,
    actionResultHandler
  });
}

function reuploadResponsesAsBuyer(actionResultHandler){
  return createBidManagerUploadAction({
    label: 'Manual Entry Re-upload',
    icon,
    validStates: [ BUYER_DRAFT ],
    dialog: ReUploadResponsesAsBuyerDialog,
    actionResultHandler
  });
}
